import { inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { appRoutes } from '@tekman/onmat/constants';

export const validateGuidGuard = (route: ActivatedRouteSnapshot): boolean => {
  const router = inject(Router);

  const isValidGUID = (guid: string): boolean => {
    const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return guidRegex.test(guid);
  };

  const params = route.params;
  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      const value = params[key];
      if (!isValidGUID(value)) {
        router.navigate([appRoutes.itineraries]);
        return false;
      }
    }
  }
  return true;
};
